import { render, staticRenderFns } from "./global-alignment-assistant-preset.vue?vue&type=template&id=30d40df8"
import script from "./global-alignment-assistant-preset.vue?vue&type=script&lang=js"
export * from "./global-alignment-assistant-preset.vue?vue&type=script&lang=js"
import style0 from "./global-alignment-assistant-preset.vue?vue&type=style&index=0&id=30d40df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports